app.factory('receiverService', [ '$http', function($http) {
    return {
        get : function(po) {
            return $http({url: '/api/receivers/'+ _.toString(po),  responseType: "arraybuffer"})
            .then(res => {
                var blob = new Blob([res.data], {type: "application/vnd.ms-excel"})
                saveAs(blob, _.toString(po) + ".xls");
            })
            .catch(err => {
                alert.warning("Receiver not available yet");
                throw new Error("Receiver not available yet");
            })
        },
        find : function(filter){
            return $http.post('/api/receivers/', filter)
            .then(res => {
                return _.orderBy(res.data, ['numero_po', 'desc']);
            }, errorHandler)
        },
        request: function(po){

        }
    };
} ]);
